<script setup>
const { locale } = useI18n();
const props = defineProps({ setCursor: Function });

const modalMember = ref(null);
const handleMemberClick = (member) => {
  modalMember.value = member;
};

const variables = { limit: 5 };
const query = gql`
  query CustomPages {
    teams(last: 80, where: { language: ${locale.value
      .toString()
      .toUpperCase()} }) {
      edges {
        node {
          title
           teamconfiguration {
             email
              phone
              position
              memberImage {
                sourceUrl(size: LARGE)
              }
              description
                linkedin
          subPosition

          }
        }
      }
    }
  }
`;
const { data } = await useAsyncQuery(query, variables);

const order = [
  "Pavel Přikryl",
  "Hana Kučerová",
  "Karolína Škodová",
  "Tereza Jacinová",
  "Iva Seidlová",
  // "Riva Karo",
  "Martin Mára",
  // locale.value === "en" ? "Reception" : "Recepce",
  "Iva Čebišová",
];
</script>

<template>
  <div
    class="flex justify-center px-6"
    @mouseenter="
      setCursor(null, null, {
        'font-size': '14px',
        background: '#FFC800',
        width: '25px',
        height: '25px',
        'z-index': -1,
      })
    "
  >
    <div class="max-w-7xl">
      <div class="text-center">
        <h2 class="h1 pt-20 lg:pt-24 pb-6 lg:pb-8">
          {{ $t("contact.person.title") }}
        </h2>
        <p class="mb-9 lg:mb-12 px-6 txt-l">
          {{ $t("contact.person.subtitle") }}
        </p>
      </div>
      <div
        v-if="data"
        class="grid md:grid-cols-2 lg:grid-cols-3 content-center lg:gap-20 gap-12"
      >
        <div v-for="(name, i) in order" :key="i">
          <div
            v-for="(person, j) in data.teams.edges
              .map((edge) => edge.node)
              .filter((p) => p.title === name)"
            :key="j"
          >
            <TeamMember
              :member="person"
              from="contact"
              :set-cursor="setCursor"
              @click="handleMemberClick(person)"
            />
          </div>
        </div>
      </div>
    </div>
    <TeamModal
      v-if="modalMember"
      :member="modalMember"
      :handle-member-click="handleMemberClick"
      :set-cursor="setCursor"
    />
  </div>
</template>

<style scoped></style>
